import { MedicalCodeControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface useAddDiagnosisCodeParams {
  medicalCodeId: string;
  status: boolean;
  xTENANTID?: string;
}

/**
 * @author rajkumar rathod
 */
export const useStatusUpdateCatalogCode = () =>
  useMutationWithLoading(async (params: useAddDiagnosisCodeParams) =>
    new MedicalCodeControllerApi(getConfigObject()).updateMedicalCodeStatus(
      params?.medicalCodeId,
      params.status,
      params.xTENANTID
    )
  );
